// Canonical Auth0 redirect path used by config.js (REACT_APP_AUTH0_CALLBACK_PATH default).
export const CANONICAL_CALLBACK_PATH = '/auth/callback';

// Legacy path. Kept as a compatibility entry while deployed Auth0 tenants whose
// Allowed Callback URLs still point at `/callback` are migrated.
export const LEGACY_CALLBACK_PATH = '/callback';

// Build the full set of route paths that must mount the auth CallbackPage.
//
// `configuredPath` is `config.auth0.callbackPath`, which is sourced from
// REACT_APP_AUTH0_CALLBACK_PATH at build time. Including it here is what stops
// the deploy-secret-driven variant of the blank-shell bug: if an environment is
// built with a non-default callback path (e.g. `/auth/cb`), Auth0 will redirect
// to that path and the app must have a Route that matches it.
//
// The canonical and legacy paths are always present so the app keeps working
// during a tenant migration where one Auth0 application still lists the legacy
// `/callback` URL.
export const buildCallbackPaths = (configuredPath) => {
    const paths = [CANONICAL_CALLBACK_PATH, LEGACY_CALLBACK_PATH];
    if (configuredPath && !paths.includes(configuredPath)) {
        paths.push(configuredPath);
    }
    return paths;
};

export const isCallbackPath = (pathname, paths = [CANONICAL_CALLBACK_PATH, LEGACY_CALLBACK_PATH]) => {
    if (!pathname) return false;
    return paths.includes(pathname);
};
